import React from 'react'
import { Link } from 'react-router-dom'
import { Button, Popover, Select, Space, Tag, Typography } from 'antd'
import { WhatsAppOutlined, PhoneOutlined } from '@ant-design/icons'

const { Text } = Typography

let nf = new Intl.NumberFormat('en-US', {
  minimumFractionDigits: 0,
  maximumFractionDigits: 0
})

export const STATUS_OPTIONS = [
  { value: 'new', label: 'New' },
  { value: 'working', label: 'Working' },
  { value: 'closed', label: 'Closed' }
]

export const statusColor = status => {
  if (status === 'new') return 'orange'
  if (status === 'working') return 'blue'
  return 'default'
}

/** One labelled line, matching the Cars table so the two sections read the same way. */
// eslint-disable-next-line react/prop-types
const Field = ({ label, children }) => (
  <div style={{ display: 'flex', gap: '6px', lineHeight: 1.5 }}>
    <Text type="secondary" style={{ fontSize: '12px', whiteSpace: 'nowrap' }}>
      {label}
    </Text>
    <span style={{ fontSize: '12px', wordBreak: 'break-word' }}>{children}</span>
  </div>
)

const excerpt = (text, length = 90) => {
  const value = String(text || '').trim()
  return value.length <= length ? value : value.slice(0, length).trimEnd() + '…'
}

export const columns = (setQuickViewId, onChangeStatus) => [
  {
    title: 'Customer',
    dataIndex: 'phone',
    key: 'phone',
    width: 210,
    // eslint-disable-next-line react/display-name
    render: (text, record) => {
      const digits = String(record.phone || '').replace(/\D/g, '')
      return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
          <Text copyable style={{ fontWeight: 600 }}>
            {record.phone}
          </Text>
          <Field label="Asked">
            {new Date(record.createdAt).toDateString()}
          </Field>
          <Space size={4}>
            <Button
              size="small"
              icon={<WhatsAppOutlined />}
              href={`https://wa.me/${digits}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              WhatsApp
            </Button>
            <Button size="small" icon={<PhoneOutlined />} href={`tel:+${digits}`}>
              Call
            </Button>
          </Space>
        </div>
      )
    }
  },
  {
    title: 'Request',
    dataIndex: 'description',
    key: 'description',
    // eslint-disable-next-line react/display-name
    render: (text, record) => (
      <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
        {/* The budget leads. It is the number that decides whether this lead is worth a call
            today, and burying it under three lines of prose is why this column exists at all. */}
        <div style={{ fontWeight: 700, fontSize: '15px' }}>
          GH₵ {nf.format(record.budgetGhs)}
        </div>
        <Popover
          content={
            <div
              style={{
                maxHeight: '320px',
                overflowY: 'auto',
                maxWidth: '420px',
                whiteSpace: 'pre-wrap'
              }}
            >
              {record.description}
            </div>
          }
          title="What they asked for"
          trigger="hover"
        >
          <span style={{ fontSize: '12px', cursor: 'pointer' }}>
            {excerpt(record.description)}
          </span>
        </Popover>
      </div>
    )
  },
  {
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
    width: 150,
    // eslint-disable-next-line react/display-name
    render: (text, record) => (
      <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
        <Tag color={statusColor(record.status)}>
          {String(record.status).toUpperCase()}
        </Tag>
        <Select
          size="small"
          value={record.status}
          options={STATUS_OPTIONS}
          onChange={value => onChangeStatus(record, value)}
          style={{ width: 120 }}
        />
      </div>
    )
  },
  {
    title: 'Action',
    key: 'action',
    fixed: 'right',
    width: 130,
    // eslint-disable-next-line react/display-name
    render: (_, record) => (
      <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
        <Link
          to={'#'}
          onClick={e => {
            e.preventDefault()
            setQuickViewId(record.id)
          }}
        >
          Quick view
        </Link>
        <Link
          to={`/car-requests/${record.id}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          Open in new tab
        </Link>
      </div>
    )
  }
]
